module.exports = __webpack_public_path__ + "img/69.4620509b.jpg";